import styles from './Footer.module.css'

const Footer = () => {
  return (
    <footer className={styles.footer}>
        <h3>Escreva sobre o livro que você está lendo!</h3>
        <p>Shelf Blog &copy; 2024</p>
    </footer>
  )
}

export default Footer